import getInstanceAxios from "../Request";

const baseDomain = process.env.REACT_APP_STORE;
const baseURL = `${baseDomain}/`;

export default getInstanceAxios(baseURL, true);
